document.addEventListener("DOMContentLoaded", () => {
  executeCodeOnce();
  observeVariantChanges();
});  

const europeanUnionCountriesPP = [
  "AT", "BE", "BG", "HR", "CY", "CZ", "DK", "EE", "FI", "FR", "DE",
  "GR", "HU", "IE", "IT", "LV", "LT", "LU", "MT", "NL", "PL", "PT",
  "RO", "SK", "SI", "ES", "SE"
];

async function isUserFromEU() {
  let countryCode = localStorage.getItem('userGeolocation');

  if (!countryCode) {
    try {
      const response = await fetch("https://ipapi.co/json/?key=K03xOHk9lT8QTYh2jPTSWC3xlWRINTnl1411kyUjFwlWGHIYnE");
      const json = await response.json();
      countryCode = json.country_code;
      localStorage.setItem('userGeolocation', countryCode);
    } catch (error) {
      console.error("❌ Не удалось определить страну пользователя:", error);
      return false;
    }
  }

  return europeanUnionCountriesPP.includes(countryCode);
}

async function changeUsdToEuroProductPage() {
  const isEU = await isUserFromEU();
  if (!isEU) {
    return;
  }

  document.querySelectorAll(".price-custom-line-thgrought, .price-custom-no-line-thgrought, .product-information #first-price .money, .product-information #final-price .money, product-information #final-price-two .money, .product-information #final-price-precents-desktop .money, product-information #final-price-precents-desktop-two .money").forEach((el) => {
    el.textContent = el.textContent
      .replace(/\$([\d.,]+)\s*USD/i, "$1 €")
      .replace(/USD\s*\$([\d.,]+)/i, "$1 €")
      .replace(/^\$([\d.,]+)/, "$1 €");
  });

}

var codeExecuted = false;
var originalPrices = {}; // Оригинальные цены для каждого варианта

async function fetchProductPrices() {
  try {
    const productHandle = window.location.pathname.split("/").pop();
    const response = await fetch(`/products/${productHandle}.js`);
    if (!response.ok) throw new Error(" Ошибка загрузки цен");

    const productData = await response.json();

    productData.variants.forEach(variant => {
      originalPrices[variant.id] = variant.price / 100;
    });

    return productData;
  } catch (error) {
    console.error(" Ошибка получения цен:", error);
    return null;
  }
}

// Функция расчёта и отображения скидки
function calculateAndDisplayDiscount(priceElement, originalPrice, discountAmount, discountType) {
  const subTotalPrice = document.querySelector("#product-subtotal-price");
  if (!originalPrice) {
    console.warn(" Оригинальная цена не найдена, пропускаем элемент:", priceElement);
    return;
  }

  var discountedPrice =
    discountType === "percentage"
      ? Math.round(originalPrice * (1 - discountAmount / 100))
      : Math.round(originalPrice - discountAmount);

  priceElement.textContent = `$${discountedPrice} USD`;
  if (subTotalPrice) {
  }
}

// Функция обновления цены и скидки
async function updateFirstPriceAndDiscounts() {
  const productData = await fetchProductPrices();
  if (!productData) {
    console.warn(" Данные о продукте не получены, прерываем обновление.");
    return;
  }

  const selectedVariantText = document.querySelector(".form__label__value")?.textContent.trim();
  if (!selectedVariantText) {
    console.warn(" Не найден текст выбранного варианта.");
    return;
  }

  const selectedVariant = productData.variants.find(variant =>
    variant.option1.toLowerCase() === selectedVariantText.toLowerCase()
  );

  if (!selectedVariant) {
    console.warn("Вариант не найден среди доступных вариантов.");
    return;
  }

  const variantId = selectedVariant.id;
  const originalPrice = originalPrices[variantId];
  if (!originalPrice) {
    console.warn(" Оригинальная цена не найдена для варианта ID:", variantId);
    return;
  }

  const firstPriceElement = document.querySelector(".product-information #first-price");
  const moneyElement = firstPriceElement?.querySelector(".money");

  if (moneyElement) {
    const currentDisplayedPrice = parseFloat(moneyElement.textContent.trim().replace("$", ""));
    if (currentDisplayedPrice !== originalPrice) {
      moneyElement.textContent = `$${originalPrice} USD`;
    } else {
    }
  } else {
    console.warn(" Не найден .money внутри #first-price!");
  }

  // Обновляем 'final-price'
  let selectors = [
    ".product-information #final-price .money",
    ".product-information #final-price-two .money",
    ".product-information #final-price-precents-desktop .money",
    ".product-information #final-price-precents-desktop-two .money"
  ];
  let finalPriceElement = selectors.map(sel => document.querySelector(sel)).find(el => el !== null);

  if (finalPriceElement) {
    finalPriceElement.textContent = `$${originalPrice} USD`;
  }

  // Применяем скидки
  applyDiscounts(variantId);

  // Переводим в евро (если нужно)
   changeUsdToEuroProductPage();
}

// Применение скидок
function applyDiscounts(variantId) {
  const originalPrice = originalPrices[variantId];
  if (!originalPrice) return;

  const discountAmountFromCMC = parseFloat(document.querySelector("#discount-amount")?.textContent || 0);
  const discountAmountFromCMCSecond = parseFloat(document.querySelector("#discount-amount-two")?.textContent || 0);
  const discountPercentsFromCMC = parseFloat(document.querySelector("#discount-percents")?.textContent || 0);
  const discountPercentsFromCMCTwo = parseFloat(document.querySelector("#discount-percents-two")?.textContent || 0);

  const priceElements = document.querySelectorAll("#final-price .money");
  const priceElementsAmountTwo = document.querySelectorAll("#final-price-two .money");
  const priceElementsPercents = document.querySelectorAll("#final-price-precents-desktop .money");
  const priceElementsPercentsTwo = document.querySelectorAll("#final-price-precents-desktop-two .money");

  priceElements.forEach(price => {
    calculateAndDisplayDiscount(price, originalPrice, discountAmountFromCMC, "amount");
  });

  priceElementsAmountTwo.forEach(price => {
    calculateAndDisplayDiscount(price, originalPrice, discountAmountFromCMCSecond, "amount");
  });

  priceElementsPercents.forEach(price => {
    calculateAndDisplayDiscount(price, originalPrice, discountPercentsFromCMC, "percentage");
  });

  priceElementsPercentsTwo.forEach(price => {
    calculateAndDisplayDiscount(price, originalPrice, discountPercentsFromCMCTwo, "percentage");
  });
}

// Однократное выполнение
async function executeCodeOnce() {
  if (codeExecuted) return;
  await updateFirstPriceAndDiscounts();
  codeExecuted = true;
}

// Отслеживание изменений варианта
function observeVariantChanges() {
  const targetNode = document.querySelector(".form__label__value");
  if (!targetNode) return;

  const config = { childList: true, subtree: true };
  const callback = async function () {
    await updateFirstPriceAndDiscounts();
  };

  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
}